import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiShield, FiFileText, FiClock, FiInfo } from 'react-icons/fi';

/** Cookie policy page. File is not named *Cookie*Policy* to avoid ad-blockers blocking the dev module URL (ERR_BLOCKED_BY_CLIENT). */
const PrivacyCookies = () => {
  return (
    <div className="bg-[#050505] min-h-screen pt-44 pb-32 px-6 grid-pattern">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-4xl mx-auto"
      >
        <header className="mb-20 border-b border-white/5 pb-12">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 bg-[#CCFF00] flex items-center justify-center text-black">
              <SafeIcon icon={FiInfo} className="text-xl" />
            </div>
            <div>
              <h2 className="text-[#CCFF00] font-mono-data text-[10px] font-black uppercase tracking-[0.4em]">Privacy Protocol</h2>
              <p className="text-white font-black uppercase tracking-tighter">Cookie Edition v1.0</p>
            </div>
          </div>
          <h1 className="text-6xl md:text-8xl font-black text-white leading-[0.85] tracking-tighter mb-8 uppercase">
            Cookie <br />
            <span className="text-transparent" style={{ WebkitTextStroke: '1px #CCFF00' }}>
              Policy
            </span>
          </h1>

          <div className="flex items-center gap-6 text-slate-500 font-mono-data text-[10px] uppercase tracking-widest">
            <div className="flex items-center gap-2">
              <SafeIcon icon={FiClock} className="text-[#CCFF00]" /> Last Updated: 5th of May 2026
            </div>
            <div className="flex items-center gap-2">
              <SafeIcon icon={FiFileText} className="text-[#CCFF00]" /> Ref: B2B-CKIE-2026
            </div>
          </div>
        </header>

        <div className="space-y-16">
          <section>
            <p className="text-xl text-slate-300 font-medium leading-relaxed italic mb-12">
              This Cookie Policy explains how The Pitch Feed (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) uses cookies and similar technologies to recognize you when you visit our website (thepitchfeed.com). It explains what these technologies are and why we use them, as well as your rights to control our use of them.
            </p>
          </section>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-white/5 pt-12">
            <div className="md:col-span-4">
              <h3 className="text-[11px] font-black uppercase tracking-[0.4em] text-[#CCFF00] mb-4">01. What are cookies?</h3>
            </div>
            <div className="md:col-span-8 text-slate-400 leading-relaxed font-medium">
              Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners in order to make their websites work, or to work more efficiently, as well as to provide reporting information.
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-white/5 pt-12">
            <div className="md:col-span-4">
              <h3 className="text-[11px] font-black uppercase tracking-[0.4em] text-[#CCFF00] mb-4">02. Why do we use them?</h3>
            </div>
            <div className="md:col-span-8 text-slate-400 leading-relaxed font-medium">
              We use first-party and third-party cookies for several reasons. Some cookies are required for technical reasons in order for our website to operate, and we refer to these as &quot;essential&quot; or &quot;strictly necessary&quot; cookies. Other cookies enable us to track and target the interests of our users to enhance the experience on our website.
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-white/5 pt-12 bg-[#CCFF00]/5 p-8 -mx-8 border-x-0">
            <div className="md:col-span-4">
              <h3 className="text-[11px] font-black uppercase tracking-[0.4em] text-[#CCFF00] mb-4">03. Types of Cookies</h3>
            </div>
            <div className="md:col-span-8 text-slate-400 leading-relaxed font-medium space-y-6">
              <div>
                <h4 className="text-white font-bold uppercase text-xs tracking-widest mb-2">Essential Cookies</h4>
                <p>These cookies are strictly necessary to provide you with services available through our website and to use some of its features, such as access to secure areas or client dashboards.</p>
              </div>
              <div>
                <h4 className="text-white font-bold uppercase text-xs tracking-widest mb-2">Performance and Analytics</h4>
                <p>These cookies collect information that is used either in aggregate form to help us understand how our website is being used or how effective our marketing campaigns are, or to help us customize our website for you.</p>
              </div>
              <div>
                <h4 className="text-white font-bold uppercase text-xs tracking-widest mb-2">Functionality Cookies</h4>
                <p>These cookies are used to recognize you when you return to our website. This enables us to personalize our content for you and remember your preferences.</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-white/5 pt-12">
            <div className="md:col-span-4">
              <h3 className="text-[11px] font-black uppercase tracking-[0.4em] text-[#CCFF00] mb-4">04. Third-Party Cookies</h3>
            </div>
            <div className="md:col-span-8 text-slate-400 leading-relaxed font-medium">
              In some special cases, we also use cookies provided by trusted third parties. For example, if we use third-party analytics solutions to help us understand how you use the site and ways that we can improve your experience. These cookies may track things such as how long you spend on the site and the pages that you visit.
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-white/5 pt-12">
            <div className="md:col-span-4">
              <h3 className="text-[11px] font-black uppercase tracking-[0.4em] text-[#CCFF00] mb-4">05. Control Mechanism</h3>
            </div>
            <div className="md:col-span-8 text-slate-400 leading-relaxed font-medium">
              You have the right to decide whether to accept or reject cookies. You can set or amend your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our website though your access to some functionality and areas of our website may be restricted.
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-white/5 pt-12">
            <div className="md:col-span-4">
              <h3 className="text-[11px] font-black uppercase tracking-[0.4em] text-[#CCFF00] mb-4">06. Changes & Contact</h3>
            </div>
            <div className="md:col-span-8 text-slate-400 leading-relaxed font-medium space-y-4">
              <p>We may update this Cookie Policy from time to time in order to reflect changes to the cookies we use or for other operational, legal, or regulatory reasons.</p>
              <p>If you have any questions about our use of cookies or other technologies, please contact us via the contact functionality provided on our website.</p>
            </div>
          </div>

          <div className="pt-20 border-t border-white/10 text-center">
            <p className="text-[10px] font-black text-slate-600 uppercase tracking-[0.5em] mb-4">End of Document</p>
            <div className="h-1 w-20 bg-[#CCFF00] mx-auto"></div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PrivacyCookies;